import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Menu, Icon } from 'antd';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { authLogout } from '../../../store/auth/actions';

import './Nav.css';
import DebugModal from '../../../containers/DebugModal';
import { modalShow } from '../../../store/modal/actions';

class Nav extends Component {
  state = {
    current: null,
  };

  componentDidMount() {
    const loc = this.props.location.pathname;
    if (loc) {
      const getDefaultPath = loc.split('/');
      this.setState({
        current: getDefaultPath[1],
      });
    }
  }

  handleClick = e => {
    switch (e.key) {
      case 'logout':
        this.props.logout();
        break;
      case 'debug':
        this.props.showDebug();
        break;
      default:
        this.setState({ current: e.key }, () => this.props.history.push(`/${e.key}`));
    }
  };

  render() {
    const NavButtons = () => [
      <DebugModal key={1} />,
      <div className={this.props.className} key={2}>
        <Menu onClick={this.handleClick} selectedKeys={[this.state.current]} mode="horizontal">
          <Menu.Item key="campaigns">
            <Icon type="pic-left" /> Campaigns
          </Menu.Item>
          <Menu.Item key="audiences">
            <Icon type="cloud-upload" /> DSP Upload
          </Menu.Item>
          <Menu.Item key="forecasts">
            <Icon type="line-chart" /> Forecasts
          </Menu.Item>
          <Menu.SubMenu title={<Icon type="setting" />}>
            <Menu.Item key="debug">Debug info</Menu.Item>
            <Menu.Item key="logout">
              <Icon type="logout" /> Sign Out
            </Menu.Item>
          </Menu.SubMenu>
        </Menu>
      </div>,
    ];

    return <nav>{this.props.loggedIn && <NavButtons />}</nav>;
  }
}

Nav.propTypes = {
  logout: PropTypes.func.isRequired,
  loggedIn: PropTypes.bool,
};

const mapStateToProps = state => ({
  loggedIn: !!get(state, 'auth.user.token', false),
});

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(authLogout()),
  showDebug: () => dispatch(modalShow('debug-info')),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Nav)
);
